angular.module('dnecom')
    .controller('CollectionProductsModalController', CollectionProductsModalController);

CollectionProductsModalController.$inject = ['$scope', '$uibModalInstance', '$http', 'notifications', 'collectionItem', 'storeId'];

function CollectionProductsModalController($scope, $uibModalInstance, $http, notifications, collectionItem, storeId) {
    $scope.collectionItem = collectionItem;
    $scope.products = collectionItem.relatedProducts;
    $scope.storeId = storeId;
    $scope.deleteItem = function (item) {
        $http.post(Routing.generate('collection_remove_products', {'id': $scope.storeId, 'collectionId': $scope.collectionItem.id, 'productId': item.id}))
            .then(function () {
                notifications.success('Product removed from collection');
                $scope.products = _.reject($scope.products, function(el) { return el.id === item.id; });
            }, function () {
                notifications.danger('Something went wrong');
            });
    };

    $scope.setMain = function (item) {
        $http.post(Routing.generate('collection_set_main_product', {'id': $scope.storeId, 'collectionId': $scope.collectionItem.id, 'productId': item.id}))
            .then(function () {
                notifications.success('Product set as main');
                $scope.products.forEach(function (item) {
                    item.isMain = false;
                });
                item.isMain = true;
            }, function () {
                notifications.danger('Something goes wrong');
            });
    };

    $scope.close = function () {
        $uibModalInstance.close();
    };
};


